import React, { useState, useEffect } from 'react';

const AdditionModal = ({ show, addition, measureTypes, onClose, onSave }) => {
  const [newAddition, setNewAddition] = useState({
    product: '',
    quantity: '',
    measure: 'Each',
    prepInstructions: ''
  });

  useEffect(() => {
    if (addition) {
      setNewAddition(addition);
    } else {
      setNewAddition({
        product: '',
        quantity: '',
        measure: 'Each',
        prepInstructions: ''
      });
    }
  }, [addition, show]);

  const handleAddAddition = () => {
    onSave({
      ...newAddition,
      id: newAddition.id || Date.now()
    });
  };

  if (!show) return null;

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Product</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Product</label>
                <input
                  type="text"
                  className="form-control"
                  value={newAddition.product || ''}
                  onChange={(e) => setNewAddition({ ...newAddition, product: e.target.value })}
                  required
                />
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Quantity</label>
                  <input
                    type="number"
                    step="0.01"
                    className="form-control"
                    value={newAddition.quantity || ''}
                    onChange={(e) => setNewAddition({ ...newAddition, quantity: e.target.value })}
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Measure</label>
                  <select
                    className="form-control"
                    value={newAddition.measure || 'Each'}
                    onChange={(e) => setNewAddition({ ...newAddition, measure: e.target.value })}
                    required
                  >
                    {measureTypes.map((type) => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Preparation Instructions</label>
                <textarea
                  className="form-control"
                  value={newAddition.prepInstructions || ''}
                  onChange={(e) => setNewAddition({ ...newAddition, prepInstructions: e.target.value })}
                  required
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={handleAddAddition}
              >
                Add Product
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdditionModal;